import { SPage } from "src/components/spage";
import { ListTable } from "./table";
import { usePaginator } from "src/hooks/use-paginator";

interface IProps {}
export const ModuleCodesPage = ({}: IProps) => {
  const pagination = usePaginator("__module_codes__", "api/Codes/List");
  return (
    <SPage
      createOptions={{ enable: true }}
      searchOptions={{ enabled: true, ...pagination }}
      title={"Module Codes"}
    >
      <ListTable {...pagination} />
    </SPage>
  );
};
